import { getMergedArticleFilters } from '../helpers/get-merged-article-filters'
import { FiltersQuery, useFiltersQuery } from '@generated'
import { useRouter } from 'next/router'

export type RCPOFilter = Omit<
  FiltersQuery['filters']['articleAttributeFilters'][0],
  'articleFilterAttributeValues'
> & {
  articleFilterAttributeValues: (FiltersQuery['filters']['articleAttributeFilters'][0]['articleFilterAttributeValues'][0] & {
    isAvailable: boolean
  })[]
}

export function useRCPOFilters() {
  const { query } = useRouter()

  const attributeFilters = Object.keys(query)
    // Filter out the page query parameter and only keep numeric keys
    // This way we can safely assume only attribute filters remain
    .filter((key) => key !== 'page' && /^\d+$/.test(key))
    .map((key) => {
      const values = query[key] as string
      const splitValues = values.split(',')

      return {
        attributeID: parseInt(key, 10),
        attributeValueID: [...splitValues.map((v) => parseInt(v, 10))],
      }
    })
  const [{ fetching: isFetchingDefaultFilters, data: defaultFilterData }] = useFiltersQuery({
    variables: {
      filters: {
        webID: 'gpcpreown',
        collections: [1],
        brands: [150],
      },
    },
  })
  const [{ fetching: isFetchingFilters, data: filterData }] = useFiltersQuery({
    variables: {
      filters: {
        webID: 'gpcpreown',
        collections: [1],
        brands: [150],
        attributeFilters,
      },
    },
  })

  const mergedFilters = getMergedArticleFilters(
    defaultFilterData as FiltersQuery,
    filterData as FiltersQuery,
  )

  return {
    fetching: isFetchingFilters || isFetchingDefaultFilters,
    attributeFilters,
    defaultFilterData,
    filterData,
    mergedFilters,
  }
}
